module.exports = __webpack_public_path__ + "img/FormofIncorporationNNC.b9207219.png";